import React, { useState, useEffect, useMemo } from "react";
import Styles from "./TapNgoTimer.module.scss";
import classnames from "classnames";

// Components
import IconWrapper from "@vahak/core-ui/dist/components/IconWrapper";
// Hooks
// Icons
import TimerIcon from "@vahak/core/dist/icons/timer.svg";
// Methods
import { timer } from "@vahak/core/dist/methods/timer";
import { convertSecondsTime } from "../../../methods/time";
import Typography, { WeightType } from "@vahak/core-ui/dist/components/Typography";
import COLORS from "@vahak/core-ui/dist/constants/colors";
import { FontSizeType } from "@vahak/core-ui/dist/constants/fontSize";
// Constant

interface TapNgoTimerProps {
    timeLeft: number;
    active?: boolean;
    timerTemplate?: string;
    color?: COLORS;
    size?: FontSizeType;
    mSize?: FontSizeType;
    weight?: WeightType;
    timerEndCallBack?: () => void;
}

const TapNgoTimer = ({
    timeLeft,
    active = true,
    timerTemplate = "[timer]",
    color,
    size,
    mSize,
    weight,
    timerEndCallBack
}: TapNgoTimerProps) => {
    const [time, setTime] = useState(timeLeft);
    const { m, s } = convertSecondsTime(time);
    const min = m.toString().padStart(2, "0");
    const sec = s.toString().padStart(2, "0");

    useEffect(() => {
        let id: ReturnType<typeof setInterval> | undefined;
        if (active) {
            id = timer(timeLeft, setTime);
        }
        return () => {
            if (id !== undefined) {
                clearInterval(id);
            }
        };
    }, [active]);

    const TimerSlot = useMemo(
        () => (
            <span className={classnames(Styles.main, active ? Styles.active : Styles.disabled)}>
                <IconWrapper gap={"5px"} width={16} height={16}>
                    <TimerIcon /> {min}:{sec} mins
                </IconWrapper>
            </span>
        ),
        [min, sec, active]
    );

    useEffect(() => {
        if (time === 0 && timerEndCallBack) {
            timerEndCallBack?.();
        }
    }, [time]);

    return (
        <div className={classnames(Styles.main)}>
            <Typography color={color} size={size} mSize={mSize} weight={weight}>
                {timerTemplate
                    ?.split("[timer]")
                    .flatMap((item) => [item, TimerSlot])
                    .slice(0, -1)}
            </Typography>
        </div>
    );
};

export default TapNgoTimer;
